module.exports = __webpack_public_path__ + "static/media/hearth.d7bc1bfc.svg";